import React, { Component } from 'react';

import formFields from '../../util/formFields';

import './forms.css';

export class AutoPopulateForm extends Component {
  constructor(props) {
    super(props);
    this.titleRef = React.createRef();
    this.didFocusTitleRef = false;
  }

  componentDidMount() {
    if (this.titleRef.current && !this.didFocusTitleRef) {
      this.titleRef.current.focus();
      this.didFocusTitleRef = true;
    }
  }

  static renderAccntLabels(values) {
    return formFields.autoPopulatedAccountFields.map(({ label, name }) => {
      return (
        <div className="account-info-row" key={name}>
          <label className="account-info-label">{label}:</label>
          <div className="account-info-text">{values[name]}</div>
        </div>
      );
    });
  }

  static renderAgentLabels(values) {
    return formFields.autoPopulatedCSRFields.map(({ label, name }) => {
      return (
        <div className="account-info-row" key={name}>
          <label className="account-info-label">{label}:</label>
          <div className="account-info-text">{values[name]}</div>
        </div>
      );
    });
  }

  render() {
    const {
      display: { displaySearch, displayCSR },
      values,
    } = this.props;

    return (
      <div className="auto-populate-container">
        <h1 ref={this.titleRef} className="searchFormTitle" tabIndex={-1}>
          Account Information:
        </h1>
        <div className="account-info-container">
          {displaySearch && AutoPopulateForm.renderAccntLabels(values)}
          {displayCSR && AutoPopulateForm.renderAgentLabels(values)}
        </div>
      </div>
    );
  }
}
